<template>
  <div :data-testid="dataTestid">
    <div class="mb-1">Next {{ count }} runs ({{ timezoneLabel }})</div>
    <div
      v-for="(run, index) in runs"
      :key="run.utcIso"
      :data-testid="`notification-next-runs-tooltip__run--${index}`"
    >
      {{ run.local }}
    </div>
  </div>
</template>

<script>
import { getNextRunsLocal, browserTimezoneShortLabel } from '../../../utils/notificationScheduleUtils';
import { NOTIFICATION_SCHEDULE } from '../../../utils/constants';

export default {
  name: 'NotificationNextRunsTooltip',
  props: {
    schedule: { type: Object, default: () => ({}) },
    count: { type: Number, default: NOTIFICATION_SCHEDULE.NEXT_RUNS_COUNT },
    dataTestid: { type: String, default: 'notification-next-runs-tooltip' },
  },
  computed: {
    runs() {
      return getNextRunsLocal(this.schedule, this.count);
    },
    timezoneLabel() {
      return browserTimezoneShortLabel();
    },
  },
};
</script>
